<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="11">
        <div class="headline">
          Sample Scans
        </div>
        <v-card>
          <v-list>
            <ScanListItemGroup :scans="sampleScans" />
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="11">
        <div class="headline">
          Your Scans
        </div>
        <v-card>
          <v-list>
            <ScanListItemGroup :scans="userScans" />
            <v-list-item v-if="!loaded">
              <v-progress-linear indeterminate />
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      v-if="sharedPatientsWithScans.length"
      justify="center"
    >
      <v-col cols="11">
        <div class="headline">
          Scans Shared With You
        </div>
        <v-card>
          <v-list>
            <div
              v-for="(sharedPatient, sharedPatientNum) in sharedPatientsWithScans"
              :key="sharedPatient.patientId"
            >
              <v-subheader>{{ sharedPatient.patientFullName }}'s Scans</v-subheader>
              <ScanListItemGroup :scans="sharedPatient.scans" />
              <v-divider v-if="sharedPatientNum !== sharedPatientsWithScans.length - 1" />
            </div>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import sortBy from 'lodash/sortBy';
import { mapState } from 'vuex';

import http from '@/http';
import ScanListItemGroup from '@/pages/ListScansPage/ScanListItemGroup.vue';

export default {
  name: 'ListScansPage',
  components: {
    ScanListItemGroup,
  },
  data() {
    return {
      scans: [],
      sampleScans: [
        {
          id: 'sample_2_anatomical.nii.gz',
          name: 'Sample Scan 1',
          type: 'sample',
        },
        {
          id: 'sample_3_anatomical.nii.gz',
          name: 'Sample Scan 2',
          type: 'sample',
        },
        {
          id: 'sample_4_anatomical.nii.gz',
          name: 'Sample Scan 3',
          type: 'sample',
        },
      ],
      loaded: false,
    };
  },
  computed: {
    ...mapState('auth', ['user']),

    userScans() {
      return this.scans.filter((scan) => scan.patient.id === this.user.id);
    },
    sharedScans() {
      return this.scans.filter((scan) => scan.patient.id !== this.user.id);
    },
    sharedPatientsWithScans() {
      // Aggregrate shared scans with the same patient
      const byPatientId = new Map();
      this.sharedScans.forEach((scan) => {
        const { patient } = scan;
        const patientId = patient.id;

        if (!byPatientId.has(patientId)) {
          byPatientId.set(patientId, {
            patientId,
            patientFullName: `${patient.first_name} ${patient.last_name}`,
            // Used for ordering
            patientLastName: patient.last_name,
            scans: [],
          });
        }
        byPatientId.get(patientId).scans.push(scan);
      });

      // Transform into a sorted array
      return sortBy(
        Array.from(
          byPatientId.values(),
          // Also sort scans within each shared patient
          // Scan ID is a proxy for date
          (sharedPatient) => ({
            ...sharedPatient,
            scans: sortBy(sharedPatient.scans, 'id'),
          }),
        ),
        'patientLastName',
      );
    },
  },
  async created() {
    const resp = await http.request({ url: '/scan/' });
    this.scans = resp.data.map((scan) => ({
      ...scan,
      type: scan.nifti_file ? 'ready' : 'processing',
    }));
    this.loaded = true;
  },
};
</script>
